module.exports = __webpack_public_path__ + "img/mail_title_bg.263eb0fd.png";